import * as PIXI from "pixi.js";
import { AssetManager } from "../manager/AssetManager";
import { OrientationType } from "../renderer/constant/RendererConstants";
import { TitanSprite } from "./TitanSprite";
import { MovieClipProperties } from "./properties/MovieClipProperties";
/**
 * TitanClip.ts
 * A PIXI AnimatedMovieClip that can responsively switch textures
 */
export class TitanClip extends TitanSprite {
    static createMovieClip(parent, properties, portraitProperties) {
        let movieClip;
        if (properties) {
            movieClip = new TitanClip(properties, portraitProperties);
            if (movieClip && parent) {
                parent.addChild(movieClip);
            }
        }
        return movieClip;
    }
    getPixiSprite(orientation) {
        return super.getPixiSprite(orientation);
    }
    constructor(properties, portraitProperties) {
        super(properties, portraitProperties);
        this.run();
    }
    createProperties(landscapeProperties, portraitProperties) {
        super.createProperties(landscapeProperties, portraitProperties);
        this.landscapeProperties = landscapeProperties;
        this.portraitProperties = portraitProperties;
        this.uiProperties = this.uiProperties;
    }
    stripPositionAndScale(properties) {
        const clip = new MovieClipProperties(properties.id, properties.spriteSheet, properties.numberOfFrames, new PIXI.Point(0, 0), new PIXI.Point(1, 1), properties.anchor);
        clip.loop = properties.loop;
        clip.frameNames = properties.frameNames;
        return clip;
    }
    createSprites() {
        this.landscapeSprite = AssetManager.getInstance().getMovieClip(this.stripPositionAndScale(this.landscapeProperties), undefined, OrientationType.LANDSCAPE);
        this.landscapeSprite.renderable = this.renderer.isLandscape() || !this.hasPortraitProperties;
        this.addChild(this.landscapeSprite);
        if (this.hasPortraitProperties) {
            this.portraitSprite = AssetManager.getInstance().getMovieClip(this.stripPositionAndScale(this.portraitProperties), undefined, OrientationType.PORTRAIT);
            this.portraitSprite.renderable = this.renderer.isPortrait();
            this.addChild(this.portraitSprite);
        }
    }
    handleRotate(event) {
        const data = event?.getCurrentTarget() || {};
        this.uiProperties = this.getCurrentProperties(data.forceOrientation);
        super.handleRotate(event);
    }
    gotoAndStop(frameNumber) {
        const pixiSprite = this.getPixiSprite();
        this.getPixiSprite().gotoAndStop(frameNumber % pixiSprite.textures.length);
    }
    gotoAndPlay(frameNumber) {
        const pixiSprite = this.getPixiSprite();
        this.getPixiSprite().gotoAndPlay(frameNumber % pixiSprite.textures.length);
    }
    play() {
        this.getPixiSprite().play();
    }
    stop() {
        this.getPixiSprite().stop();
    }
}
//# sourceMappingURL=TitanClip.js.map